/**
 * 未割当リストで地点名の下に並ぶ補足情報の文字色。
 *
 * muted-foreground だと白背景でのコントラスト比が 4.76（数量行）、半透明を重ねた
 * 荷主名行は 2.71 まで落ちて読みにくかった（実測）。黒系に寄せて約 10 にする。
 *
 * 1.0 にしないのは、見出し（地点名 = foreground）との差を残すため。
 * 大きさだけの差にすると、どれが見出しか読み取りにくくなる。
 */
export const SUB_TEXT_COLOR = 'hsl(var(--foreground) / 0.75)';

/**
 * 荷主名など、さらに小さい字で出す補足。以前は muted-foreground に 0.7 を重ねていたが、
 * 半透明は背景に溶けるだけなので数量行と同じ濃さにする（差は字の大きさで付ける）。
 */
export const SUPPLEMENT_TEXT_COLOR = SUB_TEXT_COLOR;

/**
 * 補足情報の文字の太さ。
 *
 * 黒系に寄せてもまだ薄く見えるという指摘があった（2026/08/18）。9px・11px の小さい字は
 * 同じ色でも細いと線が細って背景に負けるため、太さで補う。
 * 見出しより太くならないよう 700 は使わない（差は字の大きさで付ける方針を維持する）。
 */
export const SUB_TEXT_WEIGHT = 600;
